module.exports = __webpack_public_path__ + "media/src/images/site-top/icon-toyama-md-0078396ab977e6215767bb5180e7489e.png";